export enum PortalPageColumnType {
	Text,
	PowerBi,
}
